export const CONFIRM_CAMPAIGN_CREATION_TEXT =
  'Êtes vous sûr de vouloir supprimer la campagne ?';
export const CONFIRM_LABEL = 'Oui';
export const DECLINE_LABEL = 'Non';
export const DUPPLICATED_CAMPAIGN_CONFIRMATION_TEXT =
  'La campagne a bien été dupliquée';
export const REMOVED_CAMPAIGN_CONFIRMATION_TEXT =
  'La campagne a bien été supprimé';
export const REMOVED_CAMPAIGN_ERROR_TEXT =
  'Une erreur a eu lieu lors de la suppression de la campagne';
export const SAVED_CAMPAIGN_CONFIRMATION_TEXT =
  'La campagne a bien été enregitrée';
export const RSS_XML_NEWSLETTER_ID_ERROR_TEXT =
  "Impossible de récupérer l'id du template pour générer le lien XML";
export const SAVED_CAMPAIGN_ERROR_TEXT =
  "Une erreur a eu lieu lors de l'enregistrement de la campagne";
export const SAVED_CAMPAIGN_DATE_ERROR_TEXT =
  'Une campagne avec la même date a déjà été créée';
export const SAVED_CAMPAIGN_LOCK_ERROR_TEXT =
  'Cette campagne a été envoyée, elle ne peut plus être modifiée';
